import React from 'react'
import { UIBadge, type UIBadgeProps } from './ui-badge'

export interface UIBadgeDefaultProps extends Omit<UIBadgeProps, 'variant' | 'children'> {
  children?: React.ReactNode
}

/**
 * UIBadgeDefault - Default Badge Block
 * 기본 스타일의 배지 컴포넌트입니다.
 * 기본적인 배지입니다.
 */
export const UIBadgeDefault = React.forwardRef<HTMLSpanElement, UIBadgeDefaultProps>(
  ({ children = "Default", ...props }, ref) => {
    return (
      <UIBadge
        ref={ref}
        variant="default"
        {...props}
      >
        {children}
      </UIBadge>
    )
  }
)

UIBadgeDefault.displayName = "UIBadgeDefault"